import { useLocation } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Footer from "../components/Footer";
import TimeBar from "../components/TimeBar";

function Mainlayout({ children }) {
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  return (
    <div className="min-vh-100 d-flex flex-column">
      {/* Header */}
      {!isLandingPage && <Header />}

      {/* Body */}
      <div className="flex-grow-1 d-flex">
        {!isLandingPage ? (
          <>
            {/* Sidebar */}
            <div
              className="bg-dark text-white d-none d-lg-flex flex-column"
              style={{ width: "260px" }}
            >
              <Sidebar />
            </div>

            {/* Page Content */}
            <div className="flex-grow-1 bg-light" style={{ background: "#f5f6fa" }}>
              <div className="border-bottom bg-white px-4 py-2 shadow-sm">
                <TimeBar />
              </div>

              <div className="p-4" >
                {children}
              </div>
            </div>
          </>
        ) : (
          children
        )}
      </div>

      {/* Footer */}
      {!isLandingPage && <Footer />}
    </div>
  );
}

export default Mainlayout;
